class allowedPaths {
  static citizens = "/citizens";
  static ganttChart = "/ganttChart";
  static nexusLanding = "/nexus-landing";
  static overview = "/overview";
}

export default allowedPaths;
